// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3i-SU","name":"ConsentHeader_name__i2fim","birthday":"ConsentHeader_birthday__AzjTd","skeleton":"ConsentHeader_skeleton__3MdhI"};